import React from 'react';
import { Footer as CEFooter } from '@arm/ce-shared-components';
import ArmGlobalFooterNavigation from '@arm/ce-shared-components/components/ArmGlobalNavigation/ArmGlobalFooterNavigation';
import config from '../../../temp/config';
import RenderingStyling from '../../../lib/RenderingStyling';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { SUPPORT_HUB_GLOBAL_NAV_APP_NAME } from '../../../constants/constants';
import { isSupportApplication } from '../../../lib/ApplicationTag';
import useTopNavigationReady from './useTopNavigationReady';

const Footer = ({ fields, rendering, route, sitecoreContext }) => {
  const isSupportTemplate = isSupportApplication(route, sitecoreContext);

  const topNavigationReady = useTopNavigationReady(isSupportTemplate);

  return (
    <div {...RenderingStyling(rendering.componentName)}>
      {isSupportTemplate ? (
        topNavigationReady && (
          <ArmGlobalFooterNavigation
            appName={SUPPORT_HUB_GLOBAL_NAV_APP_NAME}
            scriptEnvironmentHostUrl={config.REACT_APP_ARM_GLOBALNAVIGATION_HOST}
          />
        )
      ) : (
        <CEFooter
          sitecoreURI={config.REACT_APP_SITECOREURI}
          sitecoreEndpoint={config.REACT_APP_FOOTERSITECOREENDPOINT}
          sitecoreDatasource={fields.sitecoreDatasource.value}
          footerDomainUrl={config.REACT_APP_FOOTERDOMAINURL}
          data={sitecoreContext?.ssr?.footerData}
        />
      )}
    </div>
  );
};
const FooterClient = () => (
  <div>
    <CEFooter
      sitecoreURI={config.REACT_APP_SITECOREURI}
      sitecoreEndpoint={config.REACT_APP_FOOTERSITECOREENDPOINT}
      sitecoreDatasource={config.REACT_APP_FOOTERSITECOREDATASOURCE}
      footerDomainUrl={config.REACT_APP_FOOTERDOMAINURL}
    />
  </div>
);

export default withSitecoreContext()(Footer);
export { FooterClient };
